import { ESourceSystem } from '@if/core/types'
import { Delete as DeleteIcon, Edit as EditIcon } from '@mui/icons-material'
import { Box } from '@mui/material'
import { useDeleteTerritory } from '@src/data/api/territories-api/territories-api'
import { Territory, TerritoryRow } from '@src/data/types/Territory'
import { Dispatch, FC, SetStateAction, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import IconButtonWithTooltip from '../../../components/IconButtonWithTooltip'

interface ActionCellProps {
  row: TerritoryRow
  handleEdit: (row: TerritoryRow) => void
  setError: Dispatch<SetStateAction<Error | null>>
}

const ActionCell: FC<ActionCellProps> = ({ row, handleEdit, setError }) => {
  const { t } = useTranslation()
  const [deleteTerritory, isDeleting] = useDeleteTerritory()
  const cantEditOrDeleteMonoTerritory = row.sourceSystem === (ESourceSystem.Monolith as string)

  const handleDelete = useCallback(async () => {
    try {
      await deleteTerritory({ ...row } as Territory)
    } catch (err) {
      setError(err as Error)
    }
  }, [deleteTerritory, row, setError])

  return (
    <Box position="relative">
      <IconButtonWithTooltip
        onClick={() => handleEdit(row)}
        tooltip={t('common.editTerritory')}
        icon={<EditIcon />}
        disabled={cantEditOrDeleteMonoTerritory}
      />

      <IconButtonWithTooltip
        onClick={() => handleDelete()}
        tooltip={t('common.deleteTerritory')}
        icon={<DeleteIcon />}
        disabled={cantEditOrDeleteMonoTerritory || isDeleting}
      />
    </Box>
  )
}

export default ActionCell
